

editChangeController = (ChangeLogService, changeLogItem, authors) ->
    'ngInject'

    @authors = authors
    @data = changeLogItem
    @scopeOptions = ChangeLogService.scopeOptions

    @save = (data) ->
        ChangeLogService.patch(changeLogItem, data)

    return

state =
    url: '/edit'
    templateUrl: 'changeLog/new'
    controller: editChangeController
    controllerAs: 'ctrl'
    resolve: authors: (ChangeLogService) ->
        'ngInject'
        return ChangeLogService.getAuthors()


stateConfig = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'changeLog.item.edit', state

module.config stateConfig
